// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"9":"4488edd8e41c411d04e2","172":"f40e0ae8ddcf2b744374","380":"9b2af4ef6388b2be724e","895":"12a02decb942a7e84b69"}[chunkId] + ".js";
};